import { CheckmarkOutline16 } from '@carbon/icons-react';
import { Tooltip } from 'antd';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useCsatQuery, useHomeQuery } from 'queries';
import { NavItemWithCount } from '../cp-nav-bar';

export const useApprovalsAndCsatCount = () => {
  const { data: homeData } = useHomeQuery();
  const { data: csatData } = useCsatQuery();

  const approvals = useMemo(() => homeData?.approvals, [homeData]);

  return useMemo(() => {
    return (approvals?.length ?? 0) + (csatData?.length ?? 0);
  }, [approvals, csatData]);
};
export const CpApprovalAndCsatIcons: React.FC = () => {
  const count = useApprovalsAndCsatCount();

  return (
    <Tooltip title={<FormattedMessage id="cp.action_items" />}>
      <NavItemWithCount showCount={count > 0} count={count}>
        <CheckmarkOutline16 />
      </NavItemWithCount>
    </Tooltip>
  );
};
